import { PropsWithChildren } from 'react';

import MediaPlayerProvider, { MediaPlayerContext } from '@/components/app/contentPlayer/MediaPlayerProvider';
import SceneProvider from '@/components/app/scenes/SceneProvider';
import ShareProvider from '@/components/app/shareFreeContent/ShareProvider';
import QRCodeHandoffContextProvider from '@/components/QRCodeHandoff/QRCodeHandoffContext';
import AuthModalContextProvider from '@/context/AuthModalContextProvider';
import SimplifiedSignupModalContextProvider from '@/context/SimplifiedSignupModalContextProvider';
import { useThemeState } from '@/hooks/store';

import PacksProvider from '../PacksProvider';

type AppProvidersProps = PropsWithChildren<{
	// App-router callers set this: their persistent store has no `theme.webAppLayout`
	// (that Redux flag is what route structure replaces there), so the usual gate would
	// otherwise skip mounting these providers entirely.
	forceMount?: boolean;
}>;

const AppProviders = ({ children, forceMount = false }: AppProvidersProps) => {
	const theme = useThemeState();

	if (!forceMount && !theme?.webAppLayout) return <>{children}</>;

	return (
		<PacksProvider>
			<ShareProvider>
				<MediaPlayerProvider>
					<MediaPlayerContext.Consumer>
						{({ playerMode, isSessionActive }) => (
							<SceneProvider playerMode={playerMode} isSessionActive={isSessionActive}>
								<AuthModalContextProvider>
									<SimplifiedSignupModalContextProvider>
										<QRCodeHandoffContextProvider>{children}</QRCodeHandoffContextProvider>
									</SimplifiedSignupModalContextProvider>
								</AuthModalContextProvider>
							</SceneProvider>
						)}
					</MediaPlayerContext.Consumer>
				</MediaPlayerProvider>
			</ShareProvider>
		</PacksProvider>
	);
};

export default AppProviders;
